import { CloudDoneOutlined as CloudDoneOutlinedIcon } from '@mui/icons-material';

const UploadDoneOutline = (): JSX.Element => <CloudDoneOutlinedIcon fontSize="inherit" />;

export default UploadDoneOutline;
